module.exports = __webpack_public_path__ + "03_long_black.dcd6e6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_long_black.png
// module id = X3A1
// module chunks = 0